// @flow

import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: ${(props) => (props.align === "top" ? "flex-start" : "center")};
  cursor: pointer;
  height: ${(props) => (props?.height ? props?.height : "20px")};
  svg {
    flex-shrink: 0;
  }

  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
    opacity: 0.5;
  `}

  > svg {
    min-width: 16px;
    min-height: 16px;
    margin-top: 4px;
  }
`;

export const Checkbox = styled.input.attrs({ type: "checkbox" })`
  visibility: hidden;
  height: 0;
  width: 0;
`;

export const Label = styled.label`
  position: relative;
  font-size: 14px;
  padding-left: 4px;
  cursor: inherit;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
